import { TRACEPARENT_HEADER, instrumentTypes } from '../../constants';
import { createEventDescription } from '../../utils/description';
import { triggerHandlers } from '../../utils/handlers';
import { fill } from '../../utils/object';
const createFetchInteractionEvent = createEventDescription(instrumentTypes.FETCH);
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsFetch() {
    if (!('fetch' in window)) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (_e) {
        return false;
    }
}
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    // Fast path to avoid DOM I/O
    if (isNativeFetch(window.fetch)) {
        return true;
    }
    let result = false;
    const doc = global.document;
    if (doc && typeof doc.createElement === `function`) {
        try {
            const sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox?.contentWindow?.fetch) {
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        } catch (_err) {}
    }
    return result;
}
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
function getFetchMethod(fetchArgs) {
    if ('Request' in global && isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1]?.method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function getFetchUrl(fetchArgs) {
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && isInstanceOf(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
export function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    fill(global, 'fetch', function(originalFetch) {
        return function(...args) {
            const handlerData = {
                args,
                method: getFetchMethod(args),
                url: getFetchUrl(args)
            };
            return originalFetch.apply(global, args).then((response)=>{
                if (!handlerData.url.match(/intake/)) {
                    triggerHandlers(instrumentTypes.FETCH, createFetchInteractionEvent({
                        ...handlerData,
                        status_code: response.status,
                        traceid: response.headers.get(TRACEPARENT_HEADER)
                    }));
                }
                return response;
            }, (error)=>{
                if (!handlerData.url.match(/intake/)) {
                    triggerHandlers(instrumentTypes.FETCH, createFetchInteractionEvent({
                        ...handlerData,
                        error
                    }));
                }
                throw error;
            });
        };
    });
}
